import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { exhaustMap, map } from 'rxjs';

import { PublicEndpointsService } from '@app/api/marketplace/services';

import { SidenavActions } from './sidenav.slice';

@Injectable({ providedIn: 'root' })
export class SidenavEffects {
  getMerchantCount$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SidenavActions.getMerchantCount.trigger),
      exhaustMap(() =>
        this.publicEndpointsService
          .getCountOfMerchants()
          .pipe(
            map((response) => SidenavActions.getMerchantCount.success(response))
          )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly publicEndpointsService: PublicEndpointsService
  ) {}
}
